import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/event/cross.svg'


const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "mb-4 text-sm font-semibold" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.event.title), 1),
    _hoisted_3
  ]))
}